import { render } from "./PostComplete.vue?vue&type=template&id=18363b7a&ts=true"
import script from "./PostComplete.vue?vue&type=script&lang=ts&setup=true"
export * from "./PostComplete.vue?vue&type=script&lang=ts&setup=true"

import "./PostComplete.vue?vue&type=style&index=0&id=18363b7a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/PostComplete.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18363b7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18363b7a', __exports__)) {
    api.reload('18363b7a', __exports__)
  }
  
  module.hot.accept("./PostComplete.vue?vue&type=template&id=18363b7a&ts=true", () => {
    api.rerender('18363b7a', render)
  })

}


export default __exports__